// apps/web/src/hooks/useDashboardTile.ts
//
// Generic React Query hook for Dashboard tile endpoints. Each per-tile
// component (T1..T7) consumes its own endpoint via this hook.
//
// Stale time: 60s — Dashboard tiles aren't real-time-critical and the
// underlying queries are not cheap. CISOs reload the page; we don't
// re-fetch on every focus.

import { useQuery, type UseQueryResult } from '@tanstack/react-query'

const STALE_TIME_MS = 60_000

export function useDashboardTile<TData>(
  endpoint: string,
): UseQueryResult<TData, Error> {
  return useQuery<TData, Error>({
    queryKey: ['dashboard', endpoint],
    queryFn: async ({ signal }) => {
      const res = await fetch(`/api/dashboard/${endpoint}`, {
        signal,
        credentials: 'same-origin',
      })
      if (!res.ok) {
        throw new Error(`dashboard tile fetch failed: ${res.status}`)
      }
      return (await res.json()) as TData
    },
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
